export enum LegalTermsSummarySubTab {
    LegalIssues = 1,
    AdditionalNdaCovenants = 2,
}

export const LegalTermsSummarySubTabs = [
    {
        id: LegalTermsSummarySubTab.LegalIssues,
        content: 'Legal Issues',
    },
    {
        id: LegalTermsSummarySubTab.AdditionalNdaCovenants,
        content: 'Additional NDA Covenants',
    },
];
